import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCDLWZ-Fstj2_vIz3wLeckHuenPkNuB4ZQ',
  authDomain: 'accessin-media-connect.firebaseapp.com',
  projectId: 'accessin-media-connect',
  storageBucket: 'accessin-media-connect.appspot.com',
  messagingSenderId: '290462419891',
  appId: '1:290462419891:web:a77a42fe64c5715be699c6',
  measurementId: 'G-YGT5LNXMZ3',
};

initializeApp(firebaseConfig);

const db = getFirestore();

// eslint-disable-next-line import/prefer-default-export
export { db };
